import { TENANTS_URL } from '../utils/urls'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'

const fetchVersionForPlatform = (platform: string, application: string) =>
  SBAPI.Fetch<{ version: string | null }>(
    `${TENANTS_URL}/platforms/${platform}/version`,
    { application }
  ).then((response) => response.data)

export { fetchVersionForPlatform }
